export default "__VITE_ASSET__GnusmsAa__"